import { LangEum } from '@/constant'

const zhTWLang = {
  1: {
    topTitle: '飆升榜',
    title: '飆升榜',
    describe: '根據商品瀏覽、成交、收藏等指標綜合計算排序',
  },
  2: {
    topTitle: '銷量榜',
    title: '銷量榜',
    describe: '根據商品瀏覽、成交、收藏等指標綜合計算排序',
    hotFont: '熱銷指數',
  },
  3: {
    topTitle: '新品榜',
    title: '新品榜',
    describe: '根據商品瀏覽、成交、收藏等指標綜合計算排序',
    hotFont: '趨勢熱度',
  },
  hour24: '24小時',
  day7: '7天',
  hour24ShowTitle: '24小時',
  day7ShowTitle: '7天',
  filterTitle: '時間篩選',
  moreBooklist: {
    headTitle: '更多榜單',
  },
  youLike: {
    headTitle: '猜你喜歡',
    booklistIco: '榜',
  },
  breakCode: '缺貨',
  OOSExplain: '該熱賣商品尺碼當前缺貨，出價後可快速成交',
  viewList: '查看完整表單',
  cancel: '取消',
}
const zhSGLang = {
  1: {
    topTitle: '飙升榜',
    title: '飆升榜',
    describe: '根根商品浏览、成交、收藏等指标综合计算排序',
  },
  2: {
    topTitle: '销量榜',
    title: '销量榜',
    describe: '根据商品浏览、成交、收藏等指标综合计算排序',
    hotFont: '热销指数',
  },
  3: {
    topTitle: '新品榜',
    title: '新品榜',
    describe: '根据商品浏览、成交、收藏等指标综合计算排序',
    hotFont: '趋势热度',
  },
  hour24: '24小时',
  day7: '7天',
  hour24ShowTitle: '24小时',
  day7ShowTitle: '7天',
  filterTitle: '时间选择',
  moreBooklist: {
    headTitle: '更多榜单',
  },
  youLike: {
    headTitle: '猜你喜欢',
    booklistIco: '榜',
  },
  breakCode: '缺货',
  OOSExplain: '该热卖商品尺码当前缺货，出价后可快速成交',
  viewList: '查看完整表单',
  cancel: '取消',
}

const enLang = {
  1: {
    topTitle: 'TOP GAINERS',
    title: 'TOP GAINERS',
    describe: 'Ranked by % increase in size popularity and search volume',
  },
  2: {
    topTitle: 'BEST SELLERS',
    title: 'BEST SELLERS',
    describe: 'Ranked mainly by item’s sales, Wishlist & browsing data.',
    hotFont: 'Sales Index',
  },
  3: {
    topTitle: 'RISING STARS',
    title: 'LATEST',
    describe: 'Ranked by latest price updates, sales, Wishlist and browsing data.',
    hotFont: 'Trend Index',
  },
  hour24: '24 hours',
  day7: '7 days',
  hour24ShowTitle: '24H',
  day7ShowTitle: '7D',
  filterTitle: 'Sort by',
  moreBooklist: {
    headTitle: 'More rankings',
  },
  youLike: {
    headTitle: 'You may also like',
    booklistIco: 'Ranked',
  },
  breakCode: 'Stockout',
  OOSExplain:
    'Some sizes of this product are sold out. You can list them for sale if you have the inventory for the out-of-stock sizes. Sales success rate tends to increase for such listings.',
  viewList: 'View List',
  cancel: 'Cancel',
}

const jaLang = {
  1: {
    topTitle: '人気ランキング',
    title: '人気順',
    describe: '商品サイズ・人気度・検索頻度などが高い順で並べ替え',
  },
  2: {
    topTitle: '売れ筋ランキング',
    title: '売れ筋順',
    describe: '商品閲覧数・注文成立数・お気に入り追加数などをまとめた順で並べ替え',
    hotFont: 'セール指数',
  },
  3: {
    topTitle: '新着ランキング',
    title: '新着順',
    describe: '最近新出品の商品閲覧数・注文成立数・お気に入り追加数などをまとめた順で並べ替え',
    hotFont: 'トレンド指数',
  },
  hour24: '24時間',
  day7: '7日',
  hour24ShowTitle: '24時間',
  day7ShowTitle: '7日',
  filterTitle: '更新周期',
  moreBooklist: {
    headTitle: 'その他のランキング',
  },
  youLike: {
    headTitle: 'おすすめ',
    booklistIco: 'トップランク',
  },
  breakCode: '品切れ中',
  OOSExplain: '当人気商品のサイズが現在品切れたので、出品してからすぐ取引が取れます',
  viewList: '完全なリストを閲覧する',
  cancel: '取消',
}

export type LangType = typeof zhTWLang

export const langConfigMap = {
  [LangEum['zh-TW']]: zhTWLang,
  [LangEum['zh-TW2']]: zhTWLang,
  [LangEum['zh-MO']]: zhTWLang,
  [LangEum['zh-SG']]: zhSGLang,
  [LangEum['zh-MY']]: zhSGLang,
  [LangEum.en]: enLang,
  [LangEum.ja]: jaLang,
  [LangEum.zh]: zhSGLang,
}

export default langConfigMap
